import { useAppActions } from 'reducers/slices/auth/resetPasswordSlice';
import { useFetchStatus } from 'utils/fetchStatusUtils';
import { useSelector } from 'react-redux';

export default () => {
  const { resetPassword } = useAppActions();
  const { resetPasswordCreatingStatus, successMessage } = useSelector(state => state.authResetPasswordSlice);

  return {
    resetPassword,
    isPasswordReseting: useFetchStatus(resetPasswordCreatingStatus).isPending,
    successMessage,
  };
};



// WEBPACK FOOTER //
// ./src/reducers/hooks/auth/useResetPassword.js